<ng-container *ngIf="options">
    <div class="flex items-center w-full border rounded-lg hover:bg-gray-100 p-3 primary-font"
        [ngClass]="{ 'file-placeholder-container': options?.showDownloadIcon }">
        <img class="w-10 h-10 cursor-zoom-in rounded-md overflow-hidden flex-shrink-0" loading="lazy"
            [ngClass]="{ 'file-cover-image': options?.showDownloadIcon }"
            *ngIf="options.fileType === 'IMAGE' && !options.enableFileTypeAvatar" src="{{options.fileLink}}"
            alt="{{options.fileName ?? 'Untitled'}}">
        <div class="flex items-center justify-center w-10 h-10 rounded-md overflow-hidden bg-primary-100 flex-shrink-0"
            [ngClass]="{ 'file-cover-image': options?.showDownloadIcon }"
            *ngIf="options.fileType !== 'IMAGE' || options.enableFileTypeAvatar">
            <div class="flex items-center justify-center text-sm font-semibold text-primary-800 uppercase">
                {{getAttachmentType(options.fileLink)}}
            </div>
        </div>
        <div class="pl-3 flex flex-col file-placeholder-content"
            [ngClass]="{ 'displayonly-container-visible': options.displayOnly === true,'download-btn-visible' : options.showDownloadBtn }">
            <a class="text-base font-medium truncate cursor-default" *ngIf="!options.fileLink || !options.filePreview"
                [matTooltip]="options.fileName">
                {{options.fileName ?? 'Untitled'}}
            </a>
            <a class="text-base font-medium truncate hover:underline hover:text-primary-500 cursor-pointer"
                *ngIf="options.fileLink && options.filePreview" [matTooltip]="options.fileName" target="_blank"
                (click)="openFile()">
                {{options.fileName ?? 'Untitled'}}
            </a>
            <div class="text-md font-medium truncate text-secondary select-none"
                *ngIf="!utilityService.isEmptyOrUndefined(options.fileSize)">
                {{utilityService.getFileSize(options.fileSize * 1000.0)}}
            </div>
        </div>
        <div class="flex file-placeholder-content space-x-2 ml-auto mr-2 justify-end" *ngIf="options?.displayOnly === true">
            @if(options?.showVisibilityIcon && options?.visible_to_customer){
                <div
                    class="flex flex-shrink-0 rounded-full w-7 h-7 items-center justify-center"
                    [matTooltip]="('text.visible_to_customer' | translate)">
                    <em class="ti ti-world text-xl cursor-default"></em>
                </div>
            }
            <div class="flex flex-shrink-0 cursor-pointer rounded-full w-7 h-7 hover:bg-gray-300 items-center justify-center"
                matTooltip="{{'text.download' | translate}}" (click)="downloadFile($event)">
                <em class="ti ti-download text-xl"></em>
            </div>
            <div *ngIf="showRemoveButton && !options?.showVisibilityIcon"
                class="text-red-600 flex flex-shrink-0  cursor-pointer rounded-full w-7 h-7 hover:bg-gray-300 items-center justify-center"
                matTooltip="{{'delete.text' | translate}}" (click)="removeFile()">
                <em class="ti ti-trash text-xl"></em>
            </div>
            @if(options?.showVisibilityIcon) {
                <button hlmBtn variant="ghost" class="w-7 h-7 p-0.5 rounded-full hover:bg-gray-300" align="end" [brnMenuTriggerFor]="menu" scrollRestrict>
                    <em class="ti ti-dots-vertical text-xl"></em>
                </button>
                <ng-template #menu>
                    <hlm-menu>
                        <hlm-menu-group>
                            @if(options?.showVisibilityIcon) {
                                <button hlmMenuItem class="cursor-pointer" (click)="toggleVisibility()">
                                    <em class="ti mr-2 text-xl" [ngClass]="{'ti-world': !options?.visible_to_customer, 'ti-users': options?.visible_to_customer}"></em>
                                    <span class="text-md primary-font">{{ (options?.visible_to_customer ? 'text.mark_as_internal' : 'text.mark_as_public') | translate }}</span>
                                </button>
                            }
                            <button hlmMenuItem class="cursor-pointer text-red-600" (click)="removeFile()" *ngIf="showRemoveButton">
                                <em class="ti ti-trash mr-2 text-xl"></em>
                                <span class="text-md primary-font">{{ 'delete.text' | translate }}</span>
                            </button>
                        </hlm-menu-group>
                    </hlm-menu>
                </ng-template>
            }
        </div>
        <div class="flex w-10 h-10 absolute items-center justify-center file-overlay" *ngIf="options?.showDownloadIcon"
            (click)="downloadFile($event)">
            <em class="ti ti-download text-2xl text-white cursor-pointer"></em>
        </div>
        <button type="button" class="h-full -mt-5 cursor-pointer relative" (click)="removeFile()"
            *ngIf="options?.showCloseIcon" matTooltip="{{'delete.text' | translate}}">
            <mat-icon class="text-2xl absolute -ml-2 -mt-8 text-red-400">cancel</mat-icon>
        </button>
        <button *ngIf="options?.showDownloadBtn"
            class="w-7 h-7 p-1 flex items-center justify-center cussor-pointer ml-auto rounded-full hover:bg-gray-300"
            matTooltip="{{'text.download' | translate}}" (click)="downloadFile($event)">
            <em class="ti ti-download text-2xl"></em>
        </button>
    </div>
</ng-container>
